import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType, QueryConfig } from '../../../lib/react-query';
import { fetchApi } from '../../../lib/fetchApi';
import { HeaderItem } from '../types';
import { useTranslation } from 'react-i18next';

export const getHistoryCsvColumns = async (): Promise<HeaderItem[]> => {
  const response = await fetchApi.get('/surveys/historyCsvColumns') as HeaderItem[];
  return response;
}

type QueryFnType = typeof getHistoryCsvColumns;

type UseHistoryCsvColumnsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useHistoryCsvColumns = ({ config = {} }: UseHistoryCsvColumnsOptions = {}) => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    queryKey: ["historyCsvColumns", currentLanguage],
    queryFn: () => getHistoryCsvColumns(),
  });
}
